module.exports = __webpack_public_path__ + "img/Ina Abuan.cc380a61.jpg";